import Parser from 'html-react-parser'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import _ from 'lodash'
import { facebookReparse } from '../utils/facebookUtils'

export const cleanedOptions = {
  replace: domNode => {
    // do not replace if element has no attributes
    if (
      domNode.type === 'tag' &&
      domNode.name === 'iframe' &&
      _.has(domNode, 'attribs.src') &&
      _.includes(domNode.attribs.src, 'youtube')
    )
      return (
        <span className="video-holder">
          <iframe
            allowFullScreen="allowfullscreen"
            frameBorder="0"
            src={domNode.attribs.src}
            title="YouTube video"
            width={domNode.attribs.width}
            height={domNode.attribs.height}
          />
        </span>
      )
    return true
  }
}

export class CleanedBodyHTML extends Component {
  componentDidMount() {
    // Solves a race condition by the time the parsed text
    // reaches the component's html.
    setTimeout(() => {
      facebookReparse()
      // force instagram embed images to load on server side
      if (document.querySelector('.instagram-media') !== null) {
        window.instgrm.Embeds.process()
      }
    }, 500)
  }
  shouldComponentUpdate(nextProps) {
    return this.props.HTMLToClean !== nextProps.HTMLToClean
  }
  componentDidUpdate(prevProps) {
    const oldDescription = prevProps.HTMLToClean
    const newDescription = this.props.HTMLToClean
    if (oldDescription !== newDescription) facebookReparse()
  }
  render() {
    if (!this.props.HTMLToClean) return null
    const parse = Parser(this.props.HTMLToClean, cleanedOptions)
    return <div className="cleanedText">{parse}</div>
  }
}

CleanedBodyHTML.propTypes = {
  HTMLToClean: PropTypes.string.isRequired
}

export default CleanedBodyHTML
